import { z } from "zod";

import { ChatModelSchemaType } from "@adaline/provider";
import {
  ImageModalityLiteral,
  SearchResultModalityLiteral,
  TextModalityLiteral,
  ToolCallModalityLiteral,
  ToolResponseModalityLiteral,
} from "@adaline/types";

const OpenAIChatModelModalities: ChatModelSchemaType["modalities"] = [
  TextModalityLiteral,
  ImageModalityLiteral,
  ToolCallModalityLiteral,
  ToolResponseModalityLiteral,
];

const OpenAIChatModelModalitiesEnum = z.enum([
  TextModalityLiteral,
  ImageModalityLiteral,
  ToolCallModalityLiteral,
  ToolResponseModalityLiteral,
]);

const OpenAIChatModelTextModalities: ChatModelSchemaType["modalities"] = [TextModalityLiteral];

const OpenAIChatModelTextModalitiesEnum = z.enum([TextModalityLiteral]);

const OpenAIChatModelTextToolModalities: ChatModelSchemaType["modalities"] = [
  TextModalityLiteral,
  ToolCallModalityLiteral,
  ToolResponseModalityLiteral,
];

const OpenAIChatModelTextToolModalitiesEnum = z.enum([TextModalityLiteral, ToolCallModalityLiteral, ToolResponseModalityLiteral]);

const OpenAIChatModelWebSearchModalities: ChatModelSchemaType["modalities"] = [
  TextModalityLiteral,
  ImageModalityLiteral,
  ToolCallModalityLiteral,
  ToolResponseModalityLiteral,
  SearchResultModalityLiteral,
];

const OpenAIChatModelWebSearchModalitiesEnum = z.enum([
  TextModalityLiteral,
  ImageModalityLiteral,
  ToolCallModalityLiteral,
  ToolResponseModalityLiteral,
  SearchResultModalityLiteral,
]);

const OpenAIChatModelWithWebSearchModalities: ChatModelSchemaType["modalities"] = [
  TextModalityLiteral,
  ImageModalityLiteral,
  ToolCallModalityLiteral,
  ToolResponseModalityLiteral,
  SearchResultModalityLiteral,
];

const OpenAIChatModelWithWebSearchModalitiesEnum = z.enum([
  TextModalityLiteral,
  ImageModalityLiteral,
  ToolCallModalityLiteral,
  ToolResponseModalityLiteral,
  SearchResultModalityLiteral,
]);

const OpenAIChatModelProWithWebSearchModalities: ChatModelSchemaType["modalities"] = [
  TextModalityLiteral,
  ImageModalityLiteral,
  ToolCallModalityLiteral,
  ToolResponseModalityLiteral,
  SearchResultModalityLiteral,
];

const OpenAIChatModelProWithWebSearchModalitiesEnum = z.enum([
  TextModalityLiteral,
  ImageModalityLiteral,
  ToolCallModalityLiteral,
  ToolResponseModalityLiteral,
  SearchResultModalityLiteral,
]);

export {
  OpenAIChatModelModalitiesEnum,
  OpenAIChatModelModalities,
  OpenAIChatModelProWithWebSearchModalities,
  OpenAIChatModelProWithWebSearchModalitiesEnum,
  OpenAIChatModelTextModalitiesEnum,
  OpenAIChatModelTextModalities,
  OpenAIChatModelTextToolModalitiesEnum,
  OpenAIChatModelTextToolModalities,
  OpenAIChatModelWebSearchModalitiesEnum,
  OpenAIChatModelWebSearchModalities,
  OpenAIChatModelWithWebSearchModalities,
  OpenAIChatModelWithWebSearchModalitiesEnum,
};
